import Vue from 'vue'
import template from './_help-links.pug'

// @vue/component
export default Vue.extend({
  template: template(),

  methods: {
    goToPrivacyPolicy() {
      this.$emit('privacy-policy')
    },

    openLanguageSelector() {
      this.$emit('change-language')
    },

    showContactModal() {
      this.$emit('show-contact-modal')
    },

    goToAdvertising() {
      this.$emit('advertising')
    },

    goToInstitutionalInformation() {
      this.$emit('institutional-information')
    },

    goToCookiesPolicy() {
      this.$emit('cookies-policy')
    },

    goToRenting() {
      this.$emit('renting')
    },

    goToPrivacidadePolicy() {
      this.$emit('privacidade-policy')
    },
  }
})
